import { markRaw } from 'vue'

const initialState = () => ({
  status: null,
  hierarchies: markRaw([])
})

export default initialState
